import { FeaturesServiceAna, FeaturesServiceJal, FeaturesServiceJr } from '@travel/icons/features';
import { Translate } from '@travel/translation';

export enum ReservationStatusColor {
  UPCOMING = 'green',
  CANCELED = 'red',
  PAST = 'yellow',
  NOSHOW = 'red',
  MODIFIED = 'green',
  REQUESTED = 'green',
}

export enum Period {
  PAST_6_MONTH = 'PAST_6_MONTH',
  THIS_YEAR = 'THIS_YEAR',
  LAST_YEAR = 'LAST_YEAR',
  '2_YEARS_AGO' = '2_YEARS_AGO',
  '3_YEARS_AGO' = '3_YEARS_AGO',
}

export enum ServiceType {
  DOMESTIC = 'DOMESTIC',
  DAY_USE = 'DAY_USE',
  ANA = 'ANA',
  JAL = 'JAL',
  JR = 'JR',
  RENTAL_CAR = 'RENTAL_CAR',
  BUS = 'BUS',
  OVERSEAS_HOTEL = 'OVERSEAS_HOTEL',
  OVERSEAS_AIR = 'OVERSEAS_AIR',
  OVERSEAS_DP = 'OVERSEAS_DP',
  // for filtering
  DOMESTIC_DP = 'DOMESTIC_DP',
  // fallback case
  EMPTY = '',
}

export enum Status {
  UPCOMING = 'UPCOMING',
  PAST = 'PAST',
  CANCELED = 'CANCELED',
  NOSHOW = 'NOSHOW',
  REQUESTED = 'REQUESTED',
  MODIFIED = 'MODIFIED',
}

export enum Sort {
  BOOKING_DATE_ASC = 'BOOKING_DATE_ASC',
  BOOKING_DATE_DESC = 'BOOKING_DATE_DESC',
  CHECKIN_DATE_ASC = 'CHECKIN_DATE_ASC',
  CHECKIN_DATE_DESC = 'CHECKIN_DATE_DESC',
  RESERVATION_MODIFIED_DATE_ASC = 'RESERVATION_MODIFIED_DATE_ASC',
  RESERVATION_MODIFIED_DATE_DESC = 'RESERVATION_MODIFIED_DATE_DESC',
}

export enum PaymentType {
  CREDIT_CARD = 'CREDIT_CARD',
  LOCAL = 'LOCAL',
  CORPORATE_CHARGE = 'CORPORATE_CHARGE',
  ALLIANCE = 'ALLIANCE',
}

export const paymentTypeLabels = {
  CREDIT_CARD: <Translate id="MyPage_Enumeration.Payment_Method.Credit_Card" />,
  LOCAL: <Translate id="MyPage_Enumeration.Payment_Method.Pay_At_Local" />,
  CORPORATE_CHARGE: <Translate id="MyPage_Enumeration.Payment_Method.Corporate" />,
  ALLIANCE: <Translate id="MyPage_Enumeration.Payment_Method.Alliance" />,
};

export enum InstallmentsTimesEnum {
  INSTALLMENTS_1 = '1',
  INSTALLMENTS_3 = '3',
  INSTALLMENTS_5 = '5',
  INSTALLMENTS_6 = '6',
  INSTALLMENTS_10 = '10',
  INSTALLMENTS_12 = '12',
  INSTALLMENTS_15 = '15',
  INSTALLMENTS_18 = '18',
  INSTALLMENTS_20 = '20',
  INSTALLMENTS_24 = '24',
}

export const InstallmentLabels: Record<InstallmentsTimesEnum, JSX.Element> = {
  [InstallmentsTimesEnum.INSTALLMENTS_1]: (
    <Translate id="MyPage_Enumeration.CreditCardPaymentLumpSum" />
  ),
  [InstallmentsTimesEnum.INSTALLMENTS_3]: (
    <Translate id="MyPage_Enumeration.CreditCardPaymentThreeInstallments" />
  ),
  [InstallmentsTimesEnum.INSTALLMENTS_5]: (
    <Translate id="MyPage_Enumeration.CreditCardPaymentFiveInstallments" />
  ),
  [InstallmentsTimesEnum.INSTALLMENTS_6]: (
    <Translate id="MyPage_Enumeration.CreditCardPaymentSixInstallments" />
  ),
  [InstallmentsTimesEnum.INSTALLMENTS_10]: (
    <Translate id="MyPage_Enumeration.CreditCardPaymentTenInstallments" />
  ),
  [InstallmentsTimesEnum.INSTALLMENTS_12]: (
    <Translate id="MyPage_Enumeration.CreditCardPaymentTwelveInstallments" />
  ),
  [InstallmentsTimesEnum.INSTALLMENTS_15]: (
    <Translate id="MyPage_Enumeration.CreditCardPaymentFifteenInstallments" />
  ),
  [InstallmentsTimesEnum.INSTALLMENTS_18]: (
    <Translate id="MyPage_Enumeration.CreditCardPaymentEighteenInstallments" />
  ),
  [InstallmentsTimesEnum.INSTALLMENTS_20]: (
    <Translate id="MyPage_Enumeration.CreditCardPaymentTwentyInstallments" />
  ),
  [InstallmentsTimesEnum.INSTALLMENTS_24]: (
    <Translate id="MyPage_Enumeration.CreditCardPaymentTwentyFourInstallments" />
  ),
};

export const COMPANY_LOGO = {
  [ServiceType.JAL]: FeaturesServiceJal,
  [ServiceType.ANA]: FeaturesServiceAna,
  [ServiceType.JR]: FeaturesServiceJr,
};

export enum CouponStatus {
  APPLICABLE = 'APPLICABLE',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  ALREADY_APPLIED = 'ALREADY_APPLIED',
  DISABLE = 'DISABLE',
}
